/** @jsx jsx */

import { Link, Flex, jsx } from 'theme-ui'
import FacebookIcon from '~/assets/images/icons/facebook.svg'
import InstagramIcon from '~/assets/images/icons/instagram.svg'
import YoutubeIcon from '~/assets/images/icons/youtube.svg'
import TikTokIcon from '~/assets/images/icons/tiktok.svg'
import useSiteMetadataQuery from '~/hooks/graphql/queries/use-site-metadata'

const FooterSocialButton = ({ children, ...props }) => {
  return (
    <Link
      {...props}
      sx={{
        borderRadius: '100%',
        height: '33px',
        width: '33px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '10px',
        ':last-child': {
          marginRight: '0'
        },
        '& > svg': {
          height: '24px'
        }
      }}
    >
      {children}
    </Link>
  )
}

const FooterSocial = () => {
  const { site } = useSiteMetadataQuery()
  const { facebook, instagram, tiktok, youtube } = site.siteMetadata.social

  return (
    <Flex
      sx={{
        flexWrap: 'wrap',
        paddingBottom: ['1.5rem', '0'],
        marginBottom: ['1.5rem', null, '0'],
        '& a': {
          justifyContent: ['flex-start', null, null],
          flex: ['15%', 'none'],
        }
      }}
    >
      <FooterSocialButton
        href={`https://www.instagram.com/${instagram}`}
        target="_blank"
        aria-label="Instagram"
        rel="noreferrer"
      >
        <InstagramIcon />
      </FooterSocialButton>

      <FooterSocialButton
        href={`https://www.tiktok.com/${tiktok}`}
        target="_blank"
        aria-label="TikTok"
        rel="noreferrer"
      >
        <TikTokIcon />
      </FooterSocialButton>

      <FooterSocialButton
        href={`https://www.facebook.com/${facebook}`}
        target="_blank"
        aria-label="Facebook"
        rel="noreferrer"
      >
        <FacebookIcon />
      </FooterSocialButton>

      <FooterSocialButton
        href={`https://www.youtube.com/channel/${youtube}`}
        target="_blank"
        aria-label="Youtube"
        rel="noreferrer"
      >
        <YoutubeIcon />
      </FooterSocialButton>
    </Flex>
  )
}

export default FooterSocial
